import React, { FC, ReactNode } from "react";
import { Box, FormControl, FormHelperText, FormLabel, SxProps, Theme, Typography } from '@mui/material';
import { helperTextStyle, labelStyle, descriptionStyle } from "./core-form-control.styles";

export interface CoreFormControlProps {
	label?: string | null;
	description?: string | null;
	fullWidth?: boolean;
	controlSx?: SxProps<Theme>;
	labelSx?: SxProps<Theme>;
	descriptionSx?: SxProps<Theme>;
	focused?: boolean;
	disabled?: boolean;
	error?: boolean;
	id?: string;
	controlId?: string;
	children?: ReactNode;
	requiredMark?: boolean;
	helperText?: string;
}

export const CoreFormControl: FC<CoreFormControlProps> = (props) => {
	const {
		helperText,
		children,
		id,
		label,
		fullWidth,
		controlSx,
		labelSx,
		focused,
		disabled,
		error,
		requiredMark,
		description,
		descriptionSx,
		controlId,
	} = props;

	return (
		<FormControl
			focused={focused}
			disabled={disabled}
			error={error}
			fullWidth={fullWidth}
			sx={controlSx}
			id={controlId}
		>
			{label && (
				<FormLabel
					htmlFor={id}
					sx={[
						...(Array.isArray(labelStyle) ? labelStyle : [labelStyle]),
						...(Array.isArray(labelSx) ? labelSx : [labelSx]),
					]}
				>
					{label}
					{' '}
					{requiredMark && (
						<Box
							component="span"
							sx={{ ml: '4px', color: '#FF0606' }}
						>
							*
						</Box>
					)}
				</FormLabel>
			)}
			{description && (
				<Typography
					sx={[
						...(Array.isArray(descriptionStyle) ? descriptionStyle : [descriptionStyle]),
						...(Array.isArray(descriptionSx) ? descriptionSx : [descriptionSx]),
					]}
				>
					{description}
				</Typography>
			)}
			{children}
			{helperText && (
				<FormHelperText sx={helperTextStyle}>
					{helperText}
				</FormHelperText>
			)}
		</FormControl>
	);
};
